import { createI18n } from 'vue-i18n'
import en_US from '@/assets/lang/en_US.json'
import pt_BR from '@/assets/lang/pt_BR.json'

const DEFAULT_LANG = 'en-US'

const LOCALES = {
  'en-US': en_US,
  'pt-BR': pt_BR
}

const NUMBER_FORMATS = {
  'en-US': {
    currency: {
      style: 'currency' as const,
      currency: 'USD'
    },
    rounded: {
      style: 'decimal' as const,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    decimal: {
      style: 'decimal' as const,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    decimal1: {
      style: 'decimal' as const,
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    },
    percent: {
      style: 'percent' as const,
      useGrouping: false,
      minimumFractionDigits: 2
    },
    percentRounded: {
      style: 'percent' as const,
      useGrouping: false,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  }
}

const i18n = createI18n<false>({
  legacy: false,
  escapeParameterHtml: true,
  locale: DEFAULT_LANG,
  messages: LOCALES,
  numberFormats: NUMBER_FORMATS,
  warnHtmlMessage: false
})

const { t, tm, te, n } = i18n.global

export const $t = t
export const $tm = tm
export const $te = te
export const $n = n
export default i18n
